module.exports = __webpack_public_path__ + "static/media/dp3.fad8c18d.jpg";